import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importSegment = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "segment" */
                '@perpay-web/fintech/middleware/segment'
            ),
    );
